import React from 'react';
import dayjs from 'dayjs';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Estilos
import './DJTV.css';
import print from '../../assets/imgs/print.png';

//Componentes
// import DJTVLogsContainer from '../../components/DJCPLogs/DJTVLogsContainer';

function DJTV({ functions, states }) {
    const { masters, user, grapesVariety } = useGlobalContext();
    const { formatNumber, setPrint, setWatchDJTVLogs } = functions;

    const {
        watchDJTVLogs,
        DJTVData: { cabecera, items, usuario, nombre, apellido },
    } = states;

    return (
        <div className="DJTV-container">
            <h4 className="DJTV-title">
                Declaración Jurada de TV {cabecera?.serie}-
                {masters.LetterTypes?.find((lt) => lt.id === 4).nombre}-
                {formatNumber(cabecera?.numero, 4)}
            </h4>
            <section className="DJTV-info-section">
                <label className="DJTV-label">
                    <span>Habilitada: </span>
                    <p>
                        {masters.HabilitationTypes?.find(
                            (ht) => ht.id === cabecera?.habilitada
                        )?.nombre.replace('_', ' ')}
                    </p>
                </label>
                <label className="DJTV-label">
                    <span>Fecha: </span>
                    <p>{dayjs(cabecera?.fecha).format('DD-MM-YYYY')}</p>
                </label>
                <label className="DJTV-label">
                    <span>Padrones: </span>
                    <p>{cabecera?.padrones.replace('_', ', ')}</p>
                </label>
                <label className="DJTV-label">
                    <span>Timbre: </span>
                    <p>{cabecera?.timbre ? 'PAGO' : 'NO PAGO'}</p>
                </label>
                <label className="DJTV-label">
                    <span>Viñedo: </span>
                    <p>{cabecera?.viniedo}</p>
                </label>
                <label className="DJTV-label">
                    <span>Teléfono: </span>
                    <p>{cabecera?.telefono}</p>
                </label>
                <label className="DJTV-label">
                    <span>Titulares: </span>
                    <p>{cabecera?.titulares}</p>
                </label>
                <label className="DJTV-label">
                    <span>Razón Social: </span>
                    <p>{cabecera?.razon_social}</p>
                </label>
                <label className="DJTV-label">
                    <span>Tipo Documento: </span>
                    <p>
                        {
                            masters.DocumentTypes?.find(
                                (ht) => ht.id === cabecera?.doc_id_tipo
                            )?.nombre
                        }
                    </p>
                </label>
                <label className="DJTV-label">
                    <span>Número Documento: </span>
                    <p>{cabecera?.doc_id}</p>
                </label>
                <label className="DJTV-label">
                    <span>Ubicación: </span>
                    <p>
                        X: {parseInt(cabecera?.ubicacion_X)}, Y:{' '}
                        {parseInt(cabecera?.ubicacion_Y)}
                    </p>
                </label>
                <label className="DJTV-label">
                    <span>Departamento: </span>
                    <p>{cabecera?.departamento}</p>
                </label>
                <label className="DJTV-label">
                    <span>Superficie: </span>
                    <p>{cabecera?.total_Superficie} m²</p>
                </label>
                <label className="DJTV-label">
                    <span>Responsable: </span>
                    <p>
                        {nombre} {apellido} ({usuario})
                    </p>
                </label>
            </section>
            <h4 className="DJTV-title">Producción de Uva</h4>
            <section className="DJTV-info-section">
                <table>
                    <thead>
                        <tr>
                            <th>Variedad</th>
                            <th>Superficie</th>
                            <th>Kilos Ingresados</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items?.map((it, i) => {
                            return (
                                <tr key={i}>
                                    <td>
                                        {
                                            grapesVariety?.find(
                                                (gv) =>
                                                    gv.codigo === it.variedad
                                            )?.variedad
                                        }
                                    </td>
                                    <td>{it.superficie} m²</td>
                                    <td>{it.kilos} kg</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </section>
            <footer className="DJTV-footer">
                <label>
                    <span>Total Kilos de Producción: </span>
                    <p>{cabecera?.total_Kilos} kg</p>
                </label>
            </footer>
            <button
                className="btn btn-primary DJTV-btn-print"
                onClick={() => setPrint(true)}
            >
                <img className="DJTV-img-print" src={print} alt="Impresíon" />
                <small>Impresión</small>
            </button>
            {user.tipo === 3 && (
                <section className="profile-fieldset_4">
                    <h4 className="profile-title">Historial de la DJTV</h4>
                    <button
                        className="btn btn-primary profile-history_btn"
                        onClick={() => setWatchDJTVLogs(!watchDJTVLogs)}
                    >
                        {!watchDJTVLogs ? 'Ver Historial' : 'Ocultar Historial'}
                    </button>
                    {/* {watchDJTVLogs && <DJTVLogsContainer />} */}
                </section>
            )}
        </div>
    );
}

export default DJTV;
